export default __webpack_public_path__ + "static/media/home-interactive-portfolio-img-04.5ec9b764.jpg";